import React from 'react';
import { Box, Tooltip, IconButton, Avatar } from '@mui/material';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { OFFICES, PROFILE } from '../routes/routes';
import { tokens } from '../theme/tokens';

const NAV_ITEMS = [
  {
    label: 'Despachos',
    path: OFFICES,
    icon: BusinessRoundedIcon,
    match: (p) => p.startsWith('/office') || p.startsWith('/hierarchy'),
  },
  { label: 'Perfil', path: PROFILE, icon: PersonRoundedIcon, match: (p) => p === PROFILE },
];

const RAIL_WIDTH = 76;

const Rail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error('Error al cerrar sesión:', error.message);
      } else {
        navigate('/login');
      }
    } catch (error) {
      console.error('Error inesperado:', error);
    }
  };

  return (
    <Box
      component="nav"
      sx={{
        width: RAIL_WIDTH,
        flex: `0 0 ${RAIL_WIDTH}px`,
        height: '100vh',
        position: 'sticky',
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.75,
        py: 2.5,
        backgroundColor: 'rgba(255,255,255,.75)',
        borderRight: `1px solid ${tokens.colors.line}`,
        backdropFilter: 'blur(14px)',
      }}
    >
      {/* Navegación */}
      {NAV_ITEMS.map(({ label, path, icon: Icon, match }) => {
        const active = match(location.pathname);
        return (
          <Tooltip key={path} title={label} placement="right" arrow>
            <IconButton
              onClick={() => navigate(path)}
              sx={{
                width: 46,
                height: 46,
                borderRadius: '14px',
                color: active ? tokens.colors.txt : tokens.colors.muted,
                backgroundImage: active ? tokens.gradient.soft : 'none',
                position: 'relative',
                '&:hover': {
                  backgroundColor: active ? undefined : tokens.colors.panel2,
                  color: tokens.colors.txt,
                },
                '&::before': active
                  ? {
                      content: '""',
                      position: 'absolute',
                      left: -20,
                      top: 12,
                      bottom: 12,
                      width: 3,
                      borderRadius: '4px',
                      backgroundImage: tokens.gradient.main,
                    }
                  : undefined,
              }}
            >
              <Icon sx={{ fontSize: 21 }} />
            </IconButton>
          </Tooltip>
        );
      })}

      <Box sx={{ flex: 1 }} />

      <Tooltip title="Cerrar sesión" placement="right" arrow>
        <IconButton
          onClick={handleLogout}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '12px',
            color: tokens.colors.muted,
            '&:hover': { color: tokens.colors.red, backgroundColor: tokens.colors.panel2 },
          }}
        >
          <LogoutRoundedIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Perfil" placement="right" arrow>
        <Avatar
          onClick={() => navigate(PROFILE)}
          sx={{
            width: 40,
            height: 40,
            cursor: 'pointer',
            fontWeight: 700,
            fontSize: 13,
            color: '#0a0b10',
            backgroundImage: tokens.gradient.avatar,
          }}
        >
          {/* TODO: reemplazar por iniciales reales desde SessionContext cuando se integre */}
          U
        </Avatar>
      </Tooltip>
    </Box>
  );
};

export default Rail;
export { RAIL_WIDTH };